import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, createJSONStorage } from 'zustand/middleware';

// Import variables
import { TV_PATHS } from 'components/routes/tv_routes/paths';

type Data = {
	pathname: string;
	title?: string | null;
	cover?: string | null;
};

type Store = Data & {
	setProtectedPage: (data: Data) => void;
	clearProtectedPage: () => void;
};

const initial = {
	pathname: TV_PATHS.MAIN,
	title: null,
	cover: null
};

export const useProtectedPage = create<Store>()(
	immer(
		persist(
			(set) => ({
				...initial,
				setProtectedPage: ({ pathname = '/', title, cover }) =>
					set((state) => {
						state.pathname = pathname;
						state.title = title;
						state.cover = cover;
					}),
				clearProtectedPage: () => {
					set(initial);
				}
			}),
			{
				name: 'protected',
				storage: createJSONStorage(() => localStorage)
			}
		)
	)
);
